import { useState } from "react";
import TopNav from "../common/topnav";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../http/authcontex";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loading from "../loading/loading";
import Select from "react-select";
import SideNave from "../common/sidenav";
import { exportReport } from "../http/api";

export default function Report() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const authContext = useAuth();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(
    localStorage.getItem("sidebarCollapsed") === "true"
  );

  const [reportType, setReportType] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // Only the two report types you want
  const reportTypeOptions = [
    { value: "active_employees", label: "Active Employee Details" },
    { value: "resigned_employees", label: "Resigned Employee Details" },
  ];

  const handleReportTypeChange = (selectedOption) => {
    setReportType(selectedOption ? selectedOption.value : null);
  };

  const handleSubmit = () => {
    if (!reportType) {
      toast.error("Please select a report type", { position: "top-right", autoClose: 3000 });
      return;
    }

    // Only require dates for other report types (if added in future)
    const hideDates = reportType === "active_employees" || reportType === "resigned_employees";
    if (!hideDates && (!startDate || !endDate)) {
      toast.error("Please select start and end dates", { position: "top-right", autoClose: 3000 });
      return;
    }

    setLoading(true);

    exportReport(reportType, startDate, endDate)
      .then((response) => {
        setLoading(false);
        if (response.status === 200) {
          const byteArray = new Uint8Array(response.data);
          const blob = new Blob([byteArray], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `${reportType}${!hideDates ? `_${startDate}_to_${endDate}` : ""}.xlsx`;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          toast.success("Report exported successfully!", { position: "top-right", autoClose: 3000 });
        } else {
          toast.error("Failed to export the report. Please try again.", { position: "top-right", autoClose: 3000 });
        }
      })
      .catch((error) => {
        setLoading(false);
        if (error.response && error.response.status === 401) {
          authContext.logout();
          navigate("/");
        } else {
          toast.error("Error exporting report. Please try again later.", { position: "top-right", autoClose: 3000 });
        }
      });
  };

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
    localStorage.setItem("sidebarCollapsed", !isSidebarCollapsed);
  };

  const hideDates = reportType === "active_employees" || reportType === "resigned_employees";

  return (
    <div className="Reports">
      {loading && <Loading />}
      <div className={`sb-nav-fixed ${isSidebarCollapsed ? "collapsed" : ""}`}>
        <TopNav toggleSidebar={toggleSidebar} />
        <div id="layoutSidenav">
          <SideNave isSidebarCollapsed={isSidebarCollapsed} toggleSidebar={toggleSidebar} />
          <div id="layoutSidenav_content">
            <main>
              <div className="container-fluid px-4">
                <h4 className="mt-4">Reports</h4>
                <hr className="bg-warning" style={{ height: "4px" }} />
                <div className="card mb-4" style={{ maxWidth: "700px", margin: "0 auto" }}>
                  <div className="card-body shadow-sm border-0">
                    {/* Report Type Dropdown */}
                    <div className="mb-3">
                      <label htmlFor="reportType" className="form-label">Report Type</label>
                      <Select
                        id="reportType"
                        value={reportType ? reportTypeOptions.find(opt => opt.value === reportType) : null}
                        onChange={handleReportTypeChange}
                        options={reportTypeOptions}
                        placeholder="Select Report Type"
                        isDisabled={loading}
                      />
                    </div>

                    {/* Start & End Date (hidden for active/resigned reports) */}
                    {!hideDates && (
                      <>
                        <div className="mb-3">
                          <label htmlFor="startDate" className="form-label">Start Date</label>
                          <input
                            type="date"
                            id="startDate"
                            className="form-control"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            disabled={loading}
                          />
                        </div>
                        <div className="mb-3">
                          <label htmlFor="endDate" className="form-label">End Date</label>
                          <input
                            type="date"
                            id="endDate"
                            className="form-control"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            disabled={loading}
                          />
                        </div>
                      </>
                    )}

                    {/* Submit Button */}
                    <button
                      className="btn bluebtn w-100"
                      onClick={handleSubmit}
                      disabled={loading || !reportType || (!hideDates && (!startDate || !endDate))}
                    >
                      {loading ? "Exporting..." : "Export XLS"}
                    </button>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>

      <ToastContainer position="top-right" autoClose={3000} hideProgressBar newestOnTop closeOnClick pauseOnFocusLoss draggable pauseOnHover />
    </div>
  );
}